import React from "react";
import { choiceButtonData } from './util';

const ChoiceButtons = props => {

  let buttonData = choiceButtonData(props.question.bogusChoices, props.question.correctAnswer);
  return (
    <div>
      <table>
        <tbody>
          <tr>
            <td> Please choose: </td>
            <td> <button className="choiceButton" onClick={() => props.guessCallback(buttonData[0].choice)}> {buttonData[0].label} </button> </td>
            <td> <button className="choiceButton" onClick={() => props.guessCallback(buttonData[1].choice)}> {buttonData[1].label} </button> </td>
            <td> <button className="choiceButton" onClick={() => props.guessCallback(buttonData[2].choice)}> {buttonData[2].label} </button> </td>
            <td> <button className="choiceButton" onClick={() => props.guessCallback(buttonData[3].choice)}> {buttonData[3].label} </button> </td>
          </tr>
        </tbody>
      </table>
    </div>
  );

}

export default ChoiceButtons;


